import { z } from 'zod';

export const BufferTimeSchema = z.object({
  setUpTime: z.number().min(0).default(0),
  breakdownTime: z.number().min(0).default(0),
});
